<div id="calendar" class="page-layout simple fullwidth">
  <div class="content" fusePerfectScrollbar [@animate]="{ value: '*', params: { delay: '200ms', y: '50px' } }">
    <div class="cards">
      <div fxLayout="column" class="card">
        <ng-container>
          <div class="card-preview">
            <mat-icon matTooltip="{{ 'EVENT_STATUS.Approved' | translate }}" *ngIf="singleEvent.status == 1"
              class="status-icon text-success">check_circle</mat-icon>
            <mat-icon matTooltip="{{ 'EVENT_STATUS.Rejected' | translate }}" *ngIf="singleEvent.status == 0"
              class="status-icon text-danger">block</mat-icon>
            <mat-icon matTooltip="{{ 'EVENT_STATUS.Pending' | translate }}" *ngIf="singleEvent.status == 2"
              class="status-icon text-warning">help</mat-icon>

            <div [ngClass]="singleEvent.event_deleted == 1 ? 'disable' : ''" class="fuse-card">
              <label style="padding: 6px">#{{ "Naam Tamiler Katchi" | translate }}</label>

              <div class="p-16 pb-0" fxLayout="row wrap " fxLayoutGap="32px" fxLayoutAlign="space-between center">
                <div class="pr-16 top hash" fxLayout="column">
                  <div class="h2 nigalvu">#{{ singleEvent.event_id }}</div>
                  <div class="h3 secondary-text">
                    <button mat-button class="blue-A700 constens" color="primary">
                      {{ singleEvent | event_place }}
                    </button>
                  </div>

                  <div class="mt-4 make">
                    உருவாக்கப்பட்டது: #{{ singleEvent.event_entered_userId }}
                    {{
                    singleEvent.event_created_time
                    | date: "dd/MM/yyyy hh:mm a"
                    }}
                  </div>
                  <div class="mt-4 make">
                    மாற்றப்பட்டது: #{{ singleEvent.event_updated_user_id }}
                    {{
                    singleEvent.event_update_time | date: "dd/MM/yyyy hh:mm a"
                    }}
                  </div>
                </div>

                <div fxLayout="column" class="top second">
                  <div class="h1">{{ singleEvent.event_title }}</div>
                  <br />
                  <div class="h2">
                    {{
                    singleEvent.event_start_time | date: "dd/MM/yyyy hh:mm a"
                    }}
                    -
                    {{
                    singleEvent.event_end_time | date: "dd/MM/yyyy hh:mm a"
                    }}
                  </div>
                  <div class="mb-4 mt-12">
                    <button mat-flat-button style="background-color: green; color: #fff; width: 165px" color="primary"
                      class="mr-4 contri">
                      {{
                      singleEvent.totalContribution
                      | currency: "INR":"symbol":"1.0-0"
                      }}
                    </button>
                    <button class="mr-4" mat-flat-button style="background-color: red; color: #fff; width: 165px"
                      color="primary">
                      {{
                      singleEvent.totalExpense
                      | currency: "INR":"symbol":"1.0-0"
                      }}
                    </button>
                  </div>
                </div>

                <div class="top third" fxLayout="column">
                  <div class="bar1"></div>

                  <!-- <br />
                        <div class="icon">
                          <mat-icon
                            class="mr-4"
                            style="color: blue; cursor: pointer"
                            >help_outline
                          </mat-icon>
                          <mat-icon
                            class="mr-4"
                          
                            style="color: green; cursor: pointer"
                            >check_circle
                          </mat-icon>
                          <mat-icon
                            
                            style="color: red; cursor: pointer"
                            >not_interested</mat-icon
                          >
                        </div> -->
                </div>
              </div>

              <div class="h3 secondary-text">
                <button mat-button color="primary" *ngFor="let path of singleEvent.event_places">
                  {{ path }}
                </button>
              </div>

              <div class="pb-4" fxLayout="row" fxLayoutAlign="center center">
                <div class="expand">
                  <mat-icon style="cursor: pointer; color: skyblue; font-size: 30px">
                    keyboard_arrow_down</mat-icon>
                </div>
              </div>

              <div class="hidefile">
                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">விவரம்</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div class="p-12">
                      <div style="white-space: pre-line" *ngIf="singleEvent.event_description">
                        {{ singleEvent.event_description }}
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">{{
                      singleEvent?.event_subgroup?.param_1 ||
                      "முன்னெடுத்தவர்கள்" | translate
                      }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div fxLayout="row flex-wrap" class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0">
                      <div *ngFor="
                          let organizer of singleEvent.organisers
                            | event_organizer: '127'
                        " class="mt-12">
                        <mat-card class="example-card pb-0" style="width: 250px; padding: 0px !important">
                          <mat-card-header class="head">
                            <div mat-card-avatar>
                              <img mat-card-image src="{{ organizer.photo_url }}" alt="{{ organizer.name }}" />
                            </div>
                            <mat-card-title class="namesize">{{
                              organizer.name
                              }}</mat-card-title>
                            <mat-card-subtitle>{{
                              organizer.member_id
                              }}</mat-card-subtitle>
                          </mat-card-header>
                        </mat-card>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">{{
                      singleEvent?.event_subgroup?.param_2 ||
                      "களப்பணி ஆற்றியவர்கள்" | translate
                      }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div fxLayout="row flex-wrap" class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0">
                      <div *ngFor="
                          let organizer of singleEvent.organisers
                            | event_organizer: '128'
                        " class="mt-12">
                        <mat-card class="example-card pb-0" style="width: 250px; padding: 0px !important">
                          <mat-card-header class="head">
                            <div mat-card-avatar>
                              <img mat-card-image src="{{ organizer.photo_url }}" alt="{{ organizer.name }}" />
                            </div>
                            <mat-card-title class="namesize">{{
                              organizer.name
                              }}</mat-card-title>
                            <mat-card-subtitle>{{
                              organizer.member_id
                              }}</mat-card-subtitle>
                          </mat-card-header>
                        </mat-card>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">ஆதரிப்பவர்கள்</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div fxLayout="row flex-wrap" class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0">
                      <div *ngFor="
                          let organizer of singleEvent.organisers
                            | event_organizer: '129'
                        " class="mt-12">
                        <mat-card class="example-card pb-0" style="width: 250px; padding: 0px !important">
                          <mat-card-header class="head">
                            <div mat-card-avatar>
                              <img mat-card-image src="{{ organizer.photo_url }}" alt="{{ organizer.name }}" />
                            </div>
                            <mat-card-title class="namesize">{{
                              organizer.name
                              }}</mat-card-title>
                            <mat-card-subtitle>{{
                              organizer.member_id
                              }}</mat-card-subtitle>
                          </mat-card-header>
                        </mat-card>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">எதிர்ப்பவர்கள்</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div fxLayout="row flex-wrap" class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0">
                      <div *ngFor="
                          let organizer of singleEvent.organisers
                            | event_organizer: '130'
                        " class="mt-12">
                        <mat-card class="example-card pb-0" style="width: 250px; padding: 0px !important">
                          <mat-card-header class="head">
                            <div mat-card-avatar>
                              <img mat-card-image src="{{ organizer.photo_url }}" alt="{{ organizer.name }}" />
                            </div>
                            <mat-card-title class="namesize">{{
                              organizer.name
                              }}</mat-card-title>
                            <mat-card-subtitle>{{
                              organizer.member_id
                              }}</mat-card-subtitle>
                          </mat-card-header>
                        </mat-card>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">{{
                      singleEvent?.event_subgroup?.param_3 ||
                      "நிகழ்வு பொறுப்பாளர்கள்" | translate
                      }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div fxLayout="row flex-wrap" class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0">
                      <div *ngFor="
                          let organizer of singleEvent.organisers
                            | event_organizer: '126'
                        " class="mt-12">
                        <mat-card class="example-card pb-0" style="width: 250px; padding: 0px !important">
                          <mat-card-header class="head">
                            <div mat-card-avatar>
                              <img mat-card-image src="{{ organizer.photo_url }}" alt="{{ organizer.name }}" />
                            </div>
                            <mat-card-title class="namesize">{{
                              organizer.name
                              }}</mat-card-title>
                            <mat-card-subtitle>{{
                              organizer.member_id
                              }}</mat-card-subtitle>
                          </mat-card-header>
                        </mat-card>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">{{
                      singleEvent?.event_subgroup?.param_4 ||
                      "கலந்து கொண்டவர்கள்" | translate
                      }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div class="p-12">
                      <p>{{ singleEvent.num_participants }}</p>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">வா.சாவடிகள்</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div class="p-12" fxLayout="column">
                      <div *ngFor="let booth of singleEvent.event_booths">
                        {{ booth.booth_number }}, {{ booth.booth }}
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">{{
                      singleEvent?.event_subgroup?.param_5 || "கோப்புகள்"
                      | translate
                      }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <div fxLayout="row flex-wrap" class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0">
                      <mat-card *ngFor="let file of singleEvent.event_files" class="example-card s3image">
                        <s3-image *ngIf="isImage(file)" mat-card-image src="{{ API_FILES }}?dir=eventFiles/{{
                            singleEvent.event_id
                          }}&name={{ file }}" alt="" style="width: 200px" (click)="zoomImage(singleEvent)">
                        </s3-image>

                        <s3-file *ngIf="!isImage(file)" mat-card-image src="{{ API_FILES }}?dir=eventFiles/{{
                            singleEvent.event_id
                          }}&name={{ file }}" alt="" style="width: 150px">
                        </s3-file>
                      </mat-card>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">பங்களிப்புகள்</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <mat-table class="products-table" [dataSource]="dataSource" matSort
                      [@animateStagger]="{ value: '50' }" fusePerfectScrollbar>
                      <ng-container matColumnDef="contribution_id">
                        <mat-header-cell *matHeaderCellDef [ngClass]="'w-75'">#</mat-header-cell>
                        <mat-cell *matCellDef="let contribution; let i = index" [ngClass]="'w-75'">
                          <!-- <span class="mobile-label"># :</span> -->
                          {{ i + 1 }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="contributor">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{ "Contributor" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let contribution">
                          <!-- <span class="mobile-label">{{ "Contributor" | translate }} :</span> -->
                          {{ contribution.contributor || contribution.member_name }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{ "Date" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let contribution">
                          <!-- <span class="mobile-label">{{ "Date" | translate }} :</span> -->
                          {{ contribution.date | date: "dd/MM/yyyy" }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          ₹{{ "Amount" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let contribution">
                          <!-- <span class="mobile-label">₹{{ "Amount" | translate }} :</span> -->
                          {{ contribution.amount | currency: "INR":"symbol":"1.0-0" }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="receiptNum">
                        <mat-header-cell [ngClass]="'w-200'" *matHeaderCellDef mat-sort-header>{{
                          "Receipt" | translate
                          }}</mat-header-cell>
                        <mat-cell [ngClass]="'w-200'" *matCellDef="let contribution">
                          <!-- <span class="mobile-label">{{ "Receipt" | translate }} :</span> -->
                          {{ contribution.receiptNum }}
                          {{
                          contribution.manual_receipt_no
                          ? "(" + contribution.manual_receipt_no + ")"
                          : ""
                          }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="internal_contirbution">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{ "Internal Contribution" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let contribution">
                          <!-- <span class="mobile-label">{{ "Internal Contribution" | translate }} :</span> -->
                          <mat-icon *ngIf="contribution.internal_contirbution" class="edit active-icon green-600 s-16">
                            check</mat-icon>
                          <mat-icon *ngIf="!contribution.internal_contirbution" class="edit active-icon red-500 s-16">
                            close</mat-icon>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="paid">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                          "Paid" | translate
                          }}</mat-header-cell>
                        <mat-cell *matCellDef="let contribution">
                          <!-- <span class="mobile-label">{{ "Paid" | translate }} :</span> -->

                          <mat-icon *ngIf="contribution.paid" class="edit active-icon green-600 s-16">check</mat-icon>
                          <mat-icon *ngIf="!contribution.paid" class="edit active-icon red-500 s-16">close</mat-icon>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>

                        <mat-cell *matCellDef="let contribution" class="cell">
                          <div class="celldiv">
                            <button *ngIf="contribution.paid == 1" mat-mini-fab class="delete green-600"
                              (click)="download(contribution)">
                              <mat-icon>cloud_download</mat-icon>
                            </button>
                          </div>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="more">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>

                        <mat-cell *matCellDef="let contribution" class="cell more">
                          <div class="celldiv">
                            <button class="more_btn" mat-icon-button [matMenuTriggerFor]="menu"
                              aria-label="Example icon-button with a menu">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                              <button *ngIf="showEdit && !contribution.receipt_gen" mat-menu-item
                                (click)="edit(contribution)">
                                <mat-icon>edit</mat-icon>
                                <span>{{ "To Edit" | translate }}</span>
                              </button>
                              <button *ngIf="showEdit && !contribution.receipt_gen || showOverrideDeleteBtn"
                                mat-menu-item (click)="delete(contribution)">
                                <mat-icon>delete</mat-icon>
                                <span>{{ "To Delete" | translate }}</span>
                              </button>
                              <button mat-menu-item (click)="move(contribution)">
                                <mat-icon>move_to_inbox</mat-icon>
                                <span>{{ "Move" | translate }}</span>
                              </button>
                            </mat-menu>
                          </div>
                        </mat-cell>
                      </ng-container>

                      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

                      <mat-row *matRowDef="
                    let contribution;
                    columns: displayedColumns;
                    let i = index
                  " class="product" matRipple>
                      </mat-row>
                    </mat-table>
                  </mat-card-content>
                </mat-card>


                <mat-card class="example-card cardstle">
                  <mat-card-header class="accent">
                    <mat-card-title class="mt-4">செலவுகள்</mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="primary-50">
                    <mat-table class="products-table" [dataSource]="dataSource1" matSort
                      [@animateStagger]="{ value: '50' }" fusePerfectScrollbar>
                      <ng-container matColumnDef="expense_id">
                        <mat-header-cell *matHeaderCellDef [ngClass]="'w-75'">#</mat-header-cell>
                        <mat-cell *matCellDef="let product; let i = index" [ngClass]="'w-75'">
                          <!-- <span class="mobile-label"># :</span> -->
                          {{ i + 1 }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{ "Date" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let product">
                          <!-- <span class="mobile-label">{{ "Date" | translate }} :</span> -->
                          {{ product.create_time | date: "dd/MM/yyyy" }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="expense_title">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          {{ "Title" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let product">
                          <!-- <span class="mobile-label">{{ "Title" | translate }} :</span> -->
                          {{ product.expense_title }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          ₹{{ "Amount" | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let product">
                          <!-- <span class="mobile-label">₹{{ "Amount" | translate }} :</span> -->
                          {{ product.amount | currency: 'INR':'symbol':'1.0-0' }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="receiptNum">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                          "Receipt" | translate
                          }}</mat-header-cell>
                        <mat-cell *matCellDef="let product">
                          <!-- <span class="mobile-label">{{ "Receipt" | translate }} :</span> -->
                          {{ product.receiptNum }}
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef>{{ "Note" | translate }}/{{
                          "Expense Files" | translate
                          }}</mat-header-cell>

                        <mat-cell *matCellDef="let product" class="cell">
                          <div class="celldiv">
                            <button (click)="openNoteDialog(product.expense_description)" mat-mini-fab color="primary"
                              class="mr-4 edit">
                              <mat-icon>notes</mat-icon>
                            </button>
                            <button mat-mini-fab color="primary" class="delete">
                              <mat-icon>cloud_download</mat-icon>
                            </button>
                          </div>
                        </mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>

                        <mat-cell *matCellDef="let product" class="cell more">
                          <div class="celldiv">

                            <button class="more_btn" mat-icon-button [matMenuTriggerFor]="menu"
                              aria-label="Example icon-button with a menu">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                              <button mat-menu-item (click)="edit(product)">
                                <mat-icon>edit</mat-icon>
                                <span>{{"To Edit" | translate}}</span>
                              </button>
                              <button mat-menu-item (click)="delete(product)">
                                <mat-icon>delete</mat-icon>
                                <span>{{"To Delete" | translate}}</span>
                              </button>
                              <button mat-menu-item (click)="move(product)">
                                <mat-icon>move_to_inbox</mat-icon>
                                <span>{{"Move" | translate}}</span>
                              </button>
                            </mat-menu>
                          </div>
                        </mat-cell>
                      </ng-container>

                      <mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></mat-header-row>

                      <mat-row *matRowDef="let product; columns: displayedColumns1; let i = index" class="product"
                        matRipple>
                      </mat-row>
                    </mat-table>
                  </mat-card-content>
                </mat-card>








              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>